import { IonImg } from '@ionic/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../components/actions/Button'
import { ModalContext } from '../contexts/ModalContext'
import ModalWrapper from '../wrappers/modalWrapper/ModalWrapper'

const DHInstructions: React.FC = () => {
	const { closeModal } = useContext(ModalContext)
	const { t } = useTranslation('modals_dhInstructions')

	return (
		<ModalWrapper>
			<ol className='text-text-dark dark:text-white p-0'>
				<li>
					{t('info1-1')} <b>{t('info1-2')}</b>
					{t('info1-3')}{' '}
					<span className='dark:text-text-grey-100 text-text-grey-200'>{t('info1-4')}</span>
					<IonImg src={'../assets/dh-instructions/image1.png'} />
				</li>
				<li>
					{t('info2-1')}{' '}
					<span className='dark:text-text-grey-100 text-text-grey-200'>{t('info2-2')}</span>
					<IonImg src={'../assets/dh-instructions/image2.png'} />
				</li>
				<li>
					{t('info3-1')}
					<br />
					<span className='dark:text-text-grey-100 text-text-grey-200'>{t('info3-2')}</span>
					<IonImg src={'../assets/dh-instructions/image3.png'} />
				</li>
				<li>
					{t('info4-1')}
					<b>{t('info4-2')}</b>
					{t('info4-3')} <b>{t('info4-4')}</b> {t('info4-5')}
					<IonImg src={'../assets/dh-instructions/image4.png'} />
				</li>
				<li>
					{t('info5-1')}
					<br />
					<span className='dark:text-text-grey-100 text-text-grey-200'>{t('info5-2')}</span>
					<IonImg src={'../assets/dh-instructions/image4.png'} />
				</li>
				<li>
					<p>{t('info6-1')}</p>
					<p>{t('info6-2')}</p>
					<p>
						{t('info6-3')} <b>{t('info6-4')}</b>
					</p>
					<p>
						{t('info6-5')} <b>{t('info6-6')}</b>
					</p>
					<p>
						{t('info6-7')} <b>{t('info6-8')}</b>
					</p>
					<p>
						{t('info6-9')} <b>{t('info6-10')}</b>
					</p>
					<p>
						{t('info6-11')} <b>{t('info6-12')}</b>
					</p>
					<IonImg src={'../assets/dh-instructions/image4.png'} />
				</li>
				<li>{t('info7-1')}</li>
			</ol>

			<Button className='m-0' onClick={closeModal}>
				{t('takaisin', { ns: 'common' })}
			</Button>
		</ModalWrapper>
	)
}

export default DHInstructions
